/*
Monotype Foundry Platform API
Version 1.0.0

Definition: AssetUploadRequest

Properties:
  assets: array
*/

var AssetUploadRequest = (function () {
  function validateAssetUploadRequest (arg) {
    // Validate assets
    if (arg.assets && !(Array.isArray(arg.assets))) {
      throw new Error('AssetUploadRequest.assets: Wrong type: Got \'' + (typeof arg.assets) + '\', but expected: \'array\'')
    }
  }
  function buildAssetUploadRequest (arg) {
    var AssetUploadRequest = arg
    // Complete assets
    // Expected Type: array
    AssetUploadRequest.assets = AssetUploadRequest.assets || []
    return AssetUploadRequest
  }
  return {
    validate: validateAssetUploadRequest,
    build: buildAssetUploadRequest
  }
})()

module.exports = AssetUploadRequest
